import { Injectable } from '@angular/core';
import {BaseRestService} from '../../shared/services/base-rest.service';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from '../../shared/services/app-settings.service';
import {Observable} from 'rxjs';
import {SendBackResult} from '../../shared/models/send-back-result';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ProjectCreationService  extends BaseRestService  {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }
  protected get className(): string { return 'ProjectCreationService'; }
  protected get isAnonymous(): boolean { return false; }


  // tslint:disable-next-line:no-any
  creation(data: any): Observable<SendBackResult<boolean>> {
    const currentData = _.cloneDeep(data);
    currentData.salesforceProjectId = currentData.salesforceProjectId.trim();
    return this.post<boolean>(`/clients/project`, currentData);
  }
}
